module.exports = __webpack_public_path__ + "img/telegram.060b91ae.svg";